import React from "react";
import Lottie from "react-lottie";
// import * as loaderSbm from "../../../assets/lottieAnimationsData/data.json";
import rotator from "./rotater.json";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: rotator,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const Rotator = (size: any) => {
  return (
    <div
    // className="absolute inset-0 flex items-center justify-center"
    // style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(5px)" }}
    //   style={{
    //     position: "absolute",
    //     top: "50%",
    //     left: "50%",
    //     transform: "translate(-50%, -50%)",
    //   }}
    >
      <div className="relative" style={{ zIndex: 1 }}>
        <Lottie options={defaultOptions} height={size || 10} width={size || 10} />
      </div>
    </div>
  );
};

export default Rotator;
